import createIcon from '../../createIcon';

/**
 * @component @name SettingsPower
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyM0g5VjIxSDdWMjNaTTExIDIzSDEzVjIxSDExVjIzWk0xMyAxSDExVjExSDEzVjFaTTE2LjU2IDMuNDRMMTUuMTEgNC44OUMxNi44NCA1Ljk0IDE4IDcuODMgMTggMTBDMTggMTMuMzEgMTUuMzEgMTYgMTIgMTZDOC42OSAxNiA2IDEzLjMxIDYgMTBDNiA3LjgzIDcuMTYgNS45NCA4Ljg4IDQuODhMNy40NCAzLjQ0QzUuMzYgNC44OCA0IDcuMjggNCAxMEM0IDE0LjQyIDcuNTggMTggMTIgMThDMTYuNDIgMTggMjAgMTQuNDIgMjAgMTBDMjAgNy4yOCAxOC42NCA0Ljg4IDE2LjU2IDMuNDRaTTE1IDIzSDE3VjIxSDE1VjIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsPower = createIcon('SettingsPower', [
  [
    'path',
    {
      d: 'M7 23H9V21H7V23ZM11 23H13V21H11V23ZM13 1H11V11H13V1ZM16.56 3.44L15.11 4.89C16.84 5.94 18 7.83 18 10C18 13.31 15.31 16 12 16C8.69 16 6 13.31 6 10C6 7.83 7.16 5.94 8.88 4.88L7.44 3.44C5.36 4.88 4 7.28 4 10C4 14.42 7.58 18 12 18C16.42 18 20 14.42 20 10C20 7.28 18.64 4.88 16.56 3.44ZM15 23H17V21H15V23Z',
      key: 'qirc8p',
    },
  ],
]);

export default SettingsPower;
